import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useFirstOrderEnableTextService = () => {
  const param = useCatalogProductIdParams();
  const {
    product: {
      product_price: { first_order_discount },
    },
  } = usePdpBaseInfo(param);

  return {
    min_required_amount: first_order_discount?.min_required_amount ?? null,
  };
};
